import { rawValue } from "./cellValue";
import type { Column, SortState } from "./DataTableTypes";

const SORT_LOCALE = "en";

function isEmpty(value: unknown): boolean {
  return value === null || value === undefined || value === "";
}

/** Ascending order of two cell values; empty values always go last. */
export function compareValues(a: unknown, b: unknown): number {
  const aEmpty = isEmpty(a);
  const bEmpty = isEmpty(b);
  if (aEmpty && bEmpty) return 0;
  if (aEmpty) return 1;
  if (bEmpty) return -1;
  if (typeof a === "number" && typeof b === "number") return a - b;
  // "Yes" before "No".
  if (typeof a === "boolean" && typeof b === "boolean") return Number(b) - Number(a);
  if (Array.isArray(a) && Array.isArray(b)) return a.length - b.length;
  return String(a).localeCompare(String(b), SORT_LOCALE, { numeric: true, sensitivity: "base" });
}

/** The rows in the requested order; unchanged when there is no sort or its column is gone. */
export function sortRows<R>(rows: R[], columns: Column<R>[], sort: SortState | undefined): R[] {
  if (!sort) return rows;
  const col = columns.find((c) => c.key === sort.key);
  if (!col) return rows;
  const direction = sort.dir === "asc" ? 1 : -1;
  return [...rows].sort((a, b) => compareValues(rawValue(a, col), rawValue(b, col)) * direction);
}

/** Clicking a header cycles ascending → descending → unsorted. */
export function nextSort(current: SortState | undefined, key: string): SortState | undefined {
  if (!current || current.key !== key) return { key, dir: "asc" };
  if (current.dir === "asc") return { key, dir: "desc" };
  return undefined;
}
